<template>
  <div class="workList">
    <div class="header">
      <div class="container">
        <img class="logo" src="/img/ghltjLogo.png" alt="">
        <template v-if="gIsLogin()">
          <router-link class="nav" to="/personal_info">完善信息</router-link>
          <span class="nav" @click="logOut">退出登录</span>
        </template>
        <template v-else>
          <router-link class="nav" :to="{path:'/login?fromUrl=/ddf_vote_new?p_type=' + prizeId}">登录</router-link>
          <router-link class="nav" :to="{path:'/register?fromUrl=/ddf_vote_new?p_type=' + prizeId}">注册</router-link>
        </template>  
      </div>
    </div>
    
    <div class="container">
      <p class="voteTitle"><span>第十六届（2020）光华龙腾奖</span><span class="voteTitle2"> · {{getPrizeText}}</span><span class="voteTitle2">公众投票</span></p>
      <p class="type">
        此次公众投票权重为10%，请大家慎重投票。投票截止日期为12月16日 00:00。<br>
        希望大家多多参与，您的参与对此次网络评选至关重要！<br>
        注：每个用户享有10票的投票权利，即每人每部手机最多且需填满10票。
      </p>
      <p class="type">总人数（{{total}}），点击照片进行选择</p>
      <!-- <Table class="voteTable" stripe :columns="columns" :data="list" :loading="loading" @on-select="select" @on-select-cancel="cancel"></Table> -->
      <div v-if="loading" class="note">
        <Icon class="turn" size="50" type="ios-loading" />
        <p>加载中...</p>
      </div>
      <template v-else>
        <template v-if="total>0">
          <Row :gutter="10">
            <Col v-for="l in list" :key="l.id" :lg="6" :md="12" :sm="24" :xs="24">
              <div class="workWrap">
                  <div class="imgWrap" @click="select(l.id)">
                    <img v-if="l.avatar" class="img" :src="getImageUrlDdf(l.avatar)" @load="gCenterImg($event, 1)" alt="">
                    <span v-show="selectList.indexOf(l.id)!=-1" class="selected"></span>
                  </div>
                <div class="info">
                  <p class="ellipsis workName">
                    <span>{{l.name}}</span>
                  </p>
                  <p class="ellipsis">{{l.company}}</p>
                  <p class="ellipsis">{{l.participantExt.position}}</p>
                  <p>
                    <Tooltip theme="light" max-width="100%" placement="bottom-start">
                      <span class="colorText">个人简介</span>
                      <div style="height: 250px; overflow: scroll;" slot="content">
                        {{l.participantExt.profile}}
                      </div>
                    </Tooltip>
                    <!-- <Poptip word-wrap trigger="hover" placement="bottom-start">
                      <span class="colorText">个人简介</span>
                      <div style="height:200px;" slot="content">
                        {{l.participantExt.profile}}
                      </div>
                    </Poptip> -->
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </template>
        <div v-else class="center">
          暂无提名选手
          <!-- <img class="emptyImg" src="../assets/empty.png" alt="">
          <p>暂无提名选手</p> -->
        </div>
      </template>
      <div class="btnWrap">
        <Button v-if="!endVote" class="defaultBtn" @click="vote">{{userVote[prizeId]?'已投票':'投票'}}</Button>
        <Button v-if="endVote" disabled>投票已截止</Button>
      </div>
      <div class="jishu">
        龙腾之星提供技术支持
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <Row :gutter="30">
          <Col :lg="9" :md="9" :sm="24" :xs="24">
            <p>联系我们</p>
            <p>光华龙腾奖办公室</p>
            <p>地址：北京市大兴区金苑路26号院3号楼三层</p>
            <p>电话：15810007797</p>
            <p>传真：010-83681552</p>
            <p>邮箱：601@ddfddf.org</p>
            <p>
              <img class="code" src="/img/ghltjCode.jpg" alt="">
            </p>
          </Col>
          <Col :lg="15" :md="15" :sm="24" :xs="24">
            <p>组织机构</p>
            <p>主办：北京光华设计发展基金会</p>
            <p>战略合作媒体：新华社主管《中国名牌》杂志</p>
            <p>合作单位：中国创新设计产业战略联盟、工业和信息化部工业文化发展中心、中国机械工程学会、中国建筑装饰协会、中国勘察设计协会、中国室内装饰协会、中国工业设计协会、中国流行色协会、中国服装设计师协会、全国工商联家具装饰业商会、北京设计学会、广东省工业设计协会、浙江省工业设计协会、上海工业设计协会、深圳市工业设计协会、深圳市工业设计产业协会、清华大学美术学院、中央美术学院、浙江大学、中国美术学院、湖南大学等</p>
            <p>专业媒体：《设计》杂志、中国工业设计报、《视觉中国》、《视觉同盟》、《创意世界》、时机科技等</p>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Service from "@/api/ddfVote";
export default {
  data() {
    return {
      selectList: [],
      userVote: {},

      loading: false,
      total: 0,
      list: [],
      endVote: false,

      prizeId: null,
      prizeList: [
        {
          id: 1,
          shortName: "深圳十大杰出青年"
        }
      ]
    };
  },
  mounted() {
    this.isEnd()
    document.title =
      "公众投票 - 第十六届（2020）光华龙腾奖 · 中国设计业十大杰出青年提名奖获奖者公众投票正式开始！"
    this.prizeId = this.$route.query.p_type || 6;
    this.getPrizeList();
    if (this.gIsLogin()) {
      this.getUserDdfVote();
    }
  },
  computed: {
    getPrizeText() {
      for (let i = 0, l = this.prizeList.length; i < l; i++) {
        if (this.prizeId == this.prizeList[i].id) {
          return this.prizeList[i].shortName;
        }
      }
      return "-";
    }
  },
  methods: {
    // 投票是否截止
    isEnd(){
      let endDate = '2020-12-16'
      let dt = new Date()
      let sYear = dt.getFullYear() + ''
      let sMonth = (dt.getMonth() + 1) < 10 ? '0' + (dt.getMonth() + 1) : (dt.getMonth() + 1) + ''
      let sDate = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate() + ''
      let dNow = sYear + '-' + sMonth + '-' + sDate
      // dNow = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate()
      // console.log(dNow)
      if(dNow > endDate){
        this.endVote = true
        return true
      }
      return false
    },
    // 退出登录
    logOut() {
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      window.localStorage.removeItem("login_time");
      this.$router.go(0);
    },
    // 获取当前用户参与投票信息
    getUserDdfVote() {
      let userId = this.$store.getters.userInfo.id;
      Service.getUserDdfVote({ "userId.eq": userId })
        .then(res => {
          if (res.errorNo == 0) {
            let data = res.data;
            for (let i = 0, l = data.length; i < l; i++) {
              let p = data[i].prizeId;
              if (!this.userVote[p]) {
                this.userVote[p] = true;
              }
            }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(() => {
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 投票
    vote() {
      if (this.gIsLogin()) {
        if (this.userVote[this.prizeId]) {
          this.$Message.info("您已经参与过投票，不能重复参与。");
          return;
        }
        if (this.selectList.length == 0) {
          this.$Message.info("请选择投票人员！");
          return;
        }
        if(this.selectList.length != 10){
          this.$Message.info('请选择10人投票。')
          return
        }
        let condition = {};
        condition.prizeId = this.prizeId;
        condition.voteIds = this.selectList;
        Service.voteDdf(condition)
          .then(res => {
            if (res.errorNo == 0) {
              this.$Message.success("投票成功！");
              this.selectList = [];
              this.userVote[this.prizeId] = true;
            } else {
              this.$Message.error(res.errorMessage);
            }
          })
          .catch(() => {
            this.$Message.error("连接服务器失败，请稍后再试");
          });
      } else {
        this.$Modal.info({
          title: "提示",
          content: "登录后才能参与投票",
          okText: "去登录",
          onOk: () => {
            this.$router.push(`/login?fromUrl=/ddf_vote_new?p_type=${this.prizeId}`);
          }
        });
      }
    },
    // 选中某一项
    select(id) {
      let i = this.selectList.indexOf(id)
      if(i==-1){
        if(this.selectList.length>=10){
          this.$Message.warning('每位用户最多可为10人投票')
          return
        }else{
          this.selectList.push(id)
        }
      }else{
        this.selectList.splice(i, 1)
      }
    },
    // 获取参评类型
    getPrizeList() {
      this.loading = true;
      Service.getDDFPrize()
        .then(res => {
          if (res.errorNo == 0) {
            this.prizeList = res.data;
            // this.prizeId = this.prizeList[0].id;
            this.getList();
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(() => {
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 获取人员列表
    getList() {
      let condition = {
        page: 0,
        size: 30,
        "status.eq": 2,
        "pType.eq": this.prizeId
      };
      this.loading = true;
      Service.getDDFRegistration(condition)
        .then(res => {
          if (res.errorNo == 0) {
            this.list = res.data;
            this.total = res.totalSize;
          } else {
            this.$Message.error(res.errorMessage);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.workList {
  min-height: 100%;
  padding-top: 60px;
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    // background: url(/img/navBg.jpg) no-repeat center #ffffff;
    background: rgba(0, 0, 0, 0.85);
    background-size: cover;
    text-align: right;
    z-index: 999;

    .logo {
      float: left;
      width: 70px;
      margin-top: 4px;
    }

    .nav {
      line-height: 50px;
      color: #fff;
      padding: 0 10px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .type {
    padding: 5px 0;
    line-height: 26px;
  }
  .note {
    padding: 10px 0;
    text-align: center;

    .turn {
      animation: turn 1s linear infinite;
      margin-bottom: 10px;
    }
    @keyframes turn {
      0% {
        -webkit-transform: rotate(0deg);
      }
      25% {
        -webkit-transform: rotate(90deg);
      }
      50% {
        -webkit-transform: rotate(180deg);
      }
      75% {
        -webkit-transform: rotate(270deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
  }
  .voteTitle {
    text-align: center;
    padding: 20px 15px;
    font-size: 20px;
    color: #d30830;
  }
  .voteTitle2 {
    display: inline;
  }
  @media (max-width: 768px) {
    .voteTitle2 {
      display: block;
    }
  }
  .workWrap{
    padding: 0 10px 20px 0;
  }

  .imgWrap {
    position: relative;
    padding-bottom: 100%;
    overflow: hidden;
    background: #fff;
    border-radius: 5px;
    border: 1px solid #cecece;
    cursor: pointer;
    .img {
      position: absolute;
      top: 0;
      left: 0;
      // width: 100%;
    }
    .selected{
      position: absolute;
      right: 0;
      top: 0;
      border: 20px solid transparent;
      border-top-color: #00b7ee;
      border-right-color: #00b7ee;

      &::after{
        content: "";
        position: absolute;
        right: -15px;
        top: -13px;
        width: 15px;
        height: 8px;
        border-left: 1px solid #ffffff;
        border-bottom: 1px solid #ffffff;
        transform: rotate(-45deg);
      }
    }
  }
  .info {
    border-radius: 5px;
    box-shadow: 0 0 5px 1px rgba($color: #000000, $alpha: 0.2);
    background: #fff;
    padding: 5px 10px;
    color: #a7a7a7;

    .workName {
      font-size: 16px;
      font-weight: bold;
      color: #525252;
    }
    .colorText {
      color: #00b7ee;
      cursor: pointer;
    }
  }
  .btnWrap {
    padding: 30px 0;
    text-align: center;
  }
  .jishu {
    text-align: center;
    padding: 0 0 20px;
    font-size: 12px;
  }
  .footer {
    padding: 50px 0;
    line-height: 1.8em;
    background: #ac1a2c;
    color: #f2f2f2;

    .code {
      width: 50%;
      max-width: 110px;
      padding: 10px 0;
    }
  }
}
</style>
